import React from 'react';

/**
 * PageLoader - Componente de carga para Suspense/Lazy Loading
 * Se muestra mientras los componentes lazy se cargan
 */
const PageLoader = () => {
  return (
    <div className="min-h-screen bg-surface-base flex items-center justify-center">
      <div className="text-center">
        {/* Spinner animado */}
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-line rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-kumia-green rounded-full animate-spin"></div>
        </div>
        
        {/* Texto de carga */}
        <p className="text-content-muted text-sm font-medium">Cargando...</p>
      </div>
    </div>
  );
};

export default PageLoader;

